(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
   document.addEventListener('DOMContentLoaded', function () {
    const popup = document.querySelector('.newsletter-popup');
    const emailInput = document.querySelector('input[type="email"]');

    function toggleClose() {
      if (popup.classList.contains('open')) {
        popup.classList.remove('open');
      } else {
        popup.classList.add('open');
      }
    }

    function setPopupSeen() {
      const now = new Date();
      const expireDate = new Date(now.getTime() + 90*24*60*60*1000); // 90 days from now
      localStorage.setItem('popupSeen', expireDate);
    }

    function shouldShowPopup() {
      const popupSeen = localStorage.getItem('popupSeen');
      if (popupSeen) {
        const now = new Date();
        const expireDate = new Date(popupSeen);
        return now > expireDate;
      }
      return true;
    }

    if (popup && shouldShowPopup()) {
      const closePopup = document.querySelector('[data-popup-close]');

      closePopup.addEventListener('click', function () {
        popup.close();
        toggleClose();
      });

      popup.addEventListener('click', function (event) {
        if (event.target === popup) {
          popup.close();
          toggleClose();
        }
      });
      
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          popup.close();
          toggleClose();
        }
      });

      setTimeout(() => {
        popup.showModal();
        setPopupSeen();
        toggleClose();
      }, 5000);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
